import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home/'
import Video from '../views/Video';
import Stories from '../views/Stories';
import Services from '../views/Services';
import Admin from '../views/Admin';
import Story from '../views/Story';
import StoryEdit from '../views/StoryEdit';
import AdminHistoryPage from '@/components/Admin/AdminHistoryPage';
import AdminVideoPage from '@/components/Admin/AdminVideoPage';
import AdminCommentsPage from '@/components/Admin/AdminCommentsPage';
import AdminRequestPage from '@/components/Admin/AdminRequestPage';
import AdminPricePage from '@/components/Admin/AdminPricePage';
import Policy from '../views/Policy';
import About from '../views/About';
import store from '../store'

Vue.use(VueRouter)

  const routes = [
    {
      path: '/',
      name: 'Home',
      meta: { auth: false},
      component: Home
    },
    {
      path: '/video',
      name: 'Video',
      meta: { auth: false},
      component: Video,
      props: true
    },
    {
      path: '/stories',
      name: 'Stories',
      meta: { auth: false},
      component: Stories
    },
    {
      path: '/about',
      name: 'About',
      meta: { auth: false},
      component: About
    },
    {
      path: '/story/:id',
      name: 'Story',
      meta: { auth: false},
      component: Story
    },
    {
      path: '/storyedit/:id',
      name: 'Story',
      meta: { auth: false},
      component: StoryEdit
    },
    {
      path: '/services',
      name: 'Services',
      meta: { auth: false},
      component: Services
    },
    {
      path: '/policy',
      name: 'Policy',
      meta: { auth: false},
      component: Policy
    },
    {
      path: '/admin',
      name: 'Admin',
      meta: { auth: false},
      component: Admin
    },
    {
      path: '/admin/adminHistoryPage',
      name: 'AdminHistoryPage',
      meta: { auth: true},
      component: AdminHistoryPage
    },
    {
      path: '/admin/adminVideoPage',
      name: 'AdminVideoPage',
      meta: { auth: true},
      component: AdminVideoPage
    },
    {
      path: '/admin/adminCommentsPage',
      name: 'AdminCommentsPage',
      meta: { auth: true},
      component: AdminCommentsPage
    },
    {
      path: '/admin/adminRequestsPage',
      name: 'AdminRequestsPage',
      meta: { auth: true},
      component: AdminRequestPage
    },
    {
      path: '/admin/adminPricePage',
      name: 'AdminRequestsPage',
      meta: { auth: true},
      component: AdminPricePage
    },
  ]


const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach(async(to, from, next) => {
  const currentUser = await store.dispatch('auth/getUid')
  const requiresAuth = to.matched.some(record => record.meta.auth)

  if (requiresAuth && !currentUser) {
    next('/')
  } else {
    next()
  }
})
export default router
